import React, { useState, useEffect } from 'react';
import { Flex, Box, Card, CardBody, Heading, Stack, CardFooter, useDisclosure, SlideFade, Divider } from '@chakra-ui/react';

import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';
import { validateHexColor } from '../../../global/helpers/global-helpers';
import WarningTextMessage from '../../../global/components/helper-components/components/WarningTextMessage';



export default function BrandingGuideColorCard({
	orgBranding,
	cardTitle,
	cardDescription,
	displayedColor,
	handleSaveOrgBrandColor,
}) {
	
	const { isOpen, onToggle } = useDisclosure()
	const [cardType, setCardType] = useState("")
	const [localState, setLocalState] = useState("")
	const [colorInput, setColorInput] = useState("")
	const [colorInputError, setColorInputError] = useState(false)

	useEffect(() => {
		if (orgBranding) {
			setLocalState(orgBranding)
		}
	}, [orgBranding])

	useEffect(() => {
		if (cardTitle) {
			const { primaryColor, secondaryColor, textColorMode } = localState || {}
			switch (cardTitle) {
				case ("Brand color"): {
					setCardType("primaryColor")
					primaryColor && setColorInput(primaryColor.substring(1))

					break;
				}
				case ("Accent color"): {
					setCardType("secondaryColor")
					secondaryColor && setColorInput(secondaryColor.substring(1))
					break;
				}
				case ("Text color"): {
					setCardType("textColorMode")
					setColorInput(textColorMode ? textColorMode : "light")
					break;
				}
				default: {
					break;
				}
			}
		}
	}, [localState, cardTitle]);

	const handleClickEditButton = (name) => {
		if (cardType === name) {
			onToggle()
			setColorInputError(false)
		}
	}

	const handleSetBrandTextColor = (textColor) => {
		handleSaveOrgBrandColor('textColorMode', textColor)
	}

	const handleSetBrandColor = (hexColorInput) => {
		const validatedHexColor = validateHexColor(hexColorInput)

		if (validatedHexColor && cardType) {
			handleSaveOrgBrandColor(cardType, validatedHexColor)
		} else {
			const originalValue = localState[cardType] ? localState[cardType].substring(1) : ""
			setColorInput(originalValue)
			setColorInputError(true)
		}
	}

	function renderTextColorChoices() {
		return (
			<Flex w='100%' gap={8} justify='space-between' pb='0.75em'>
				<Box flex='1' textAlign='center' fontSize='0.8em' bg={localState.textColorMode !== "dark" && 'brand.500'} fontWeight={localState.textColorMode !== "dark" ? '600' : '500'} cursor='pointer'
					onClick={() => handleSetBrandTextColor('light')} py='0.4em' rounded='0.5em' color={localState.textColorMode !== "dark" && 'white'}
				>Light</Box>
				<Box flex='1' textAlign='center' fontSize='0.8em' bg={localState.textColorMode === "dark" && 'brand.50'} fontWeight={localState.textColorMode === "dark" ? '600' : '500'} cursor='pointer'
					onClick={() => handleSetBrandTextColor('dark')} py='0.4em' rounded='0.5em' color={localState.textColorMode === "dark" && 'brandDark.500'}
				>Dark</Box>
			</Flex>
		)
	}

	return (
		<>
			<Card minW='15em' maxW='25em'>
				<CardBody>
					<Flex w='100%' h='5em' position='relative' bg={displayedColor ? displayedColor : 'black'} border='1px solid' borderColor='gray.100' rounded='0.25em'

					>
						{(cardType === "textColorMode") &&
							<>
								<Box position='absolute'
									fontWeight='600' bottom='0em' right='0em' p='0.5em' color={localState.textColorMode === 'dark' ? "brandDark.500" : "white"}
								>Hello
									<Divider borderColor={localState?.secondaryColor ? localState.secondaryColor : 'white'} borderBottomWidth='2px' />
								</Box>

							</>
						}

					</Flex>
					<Stack mt='6' spacing='3'>
						<Heading size='md'>{cardTitle ? cardTitle : 'Default'}</Heading>
						<Box fontSize='0.8em'>
							{cardDescription ? cardDescription : '-'}
						</Box>
					</Stack>
				</CardBody>

				<CardFooter>
					{cardType === "textColorMode" ? renderTextColorChoices() :
						<Flex justify='flex-start' align='center' w='100%' gap={8}>
							<Box flex='auto'>

								{colorInputError ?
									<WarningTextMessage errorLogic={colorInputError} message='Invalid hex color' />
									:
									<SlideFade in={isOpen} offsetY='10px' offsetX='-20px'>
										<Flex justify='flex-start' align='center' w='100%' gap='2'>
											<Box as='span'>#</Box>
											<LaunchdeckFormInput
												name={cardTitle}
												onChange={(e) => {
													setColorInput(e.target.value)
												}
												}
												// onPressEnter={(e) => onPressEnter(e)}
												// onBlur={handleSaveItemByClickOutside}
												value={colorInput}
											// label='Youtube link'
											// errorLogic={displayNoVideoState}
											// errorMessage={'Invalid youtube link. Please check your link and try again'}
											/>
										</Flex>
									</SlideFade>
								}
							</Box>
							<Box flex='1'><LaunchdeckButton bg={isOpen ? 'brand.500' : 'brandDark.500'} color='white' fontSize='0.8em' py='0.4em' px='0.5em' onClick={() => {
								if (isOpen) {
									handleSetBrandColor(colorInput)
									// handleClickEditButton()
									onToggle()
								} else {
									handleClickEditButton(cardType)
								}

							}} label={isOpen ? 'OK' : displayedColor ? 'Change' : 'Set'} /></Box>
						</Flex>
					}

				</CardFooter>
			</Card>
		</>
	);
}